module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ibox', [(_vm.params.is_public != 0) ? _c('template', {
    slot: "title"
  }, [_vm._v("口コミ一覧(公開中)")]) : _vm._e(), _vm._v(" "), (_vm.params.is_public == 0) ? _c('template', {
    slot: "title"
  }, [_vm._v("口コミ一覧(公開前)")]) : _vm._e(), _vm._v(" "), _c('template', {
    slot: "tools"
  }), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('company-review-search', {
    attrs: {
      "params": _vm.params
    },
    on: {
      "update:params": function($event) {
        _vm.params = $event
      },
      "clickSearch": _vm.clickSearch
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: " col-sm-12"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("口コミ投稿ID")]), _vm._v(" "), _c('th', [_vm._v("投稿日時")]), _vm._v(" "), _c('th', [_vm._v("企業名")]), _vm._v(" "), _c('th', [_vm._v("タイトル")]), _vm._v(" "), _c('th', [_vm._v("公開/非公開")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.reviews), function(review, index) {
    return [_c('company-review-list-row', {
      attrs: {
        "review": review
      }
    })]
  })], 2)]), _vm._v(" "), _c('pager', {
    attrs: {
      "pager": _vm.pager
    },
    on: {
      "click": _vm.clickPager
    }
  })], 1)]), _vm._v(" "), _c('line-dashed')], 1)])])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b430bd2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/company/review/List.vue
// module id = 478
// module chunks = 1